// src/utils/getCategory.js

import {
  DISCIPLINES,
  buildAgeMappings,
  getSeasonStartYear,
  normalizeDiscipline,
} from "./categoryRules";

const getCategory = (
  dateOfBirth,
  cate_country = "France",
  discipline = DISCIPLINES.JUDO
) => {
  if (!dateOfBirth) return "Inconnu";

  const birthYear = new Date(dateOfBirth).getFullYear();
  if (Number.isNaN(birthYear)) return "Inconnu";

  const seasonStartYear = getSeasonStartYear();
  const disciplineKey = normalizeDiscipline(discipline);

  const mappings = buildAgeMappings(seasonStartYear);
  const categoriesByCountry =
    mappings[disciplineKey] || mappings[DISCIPLINES.JUDO];

  const categories =
    categoriesByCountry[cate_country] || categoriesByCountry["France"] || [];

  for (const cat of categories) {
    const [minYear, maxYear] = cat.range;
    if (birthYear >= minYear && birthYear <= maxYear) {
      return cat.name;
    }
  }

  return "Inconnu";
};

export default getCategory;